import { Paper } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import {
  CardsWrapper,
  ContentFilters,
  GeneralStyle,
  SearchField,
} from "./FormsManagementContainer.styled";
import Card from "../../components/ConfigurationCards";
import ListOfForms from "../../components/ListOfForms/ListOfForms";
import ModalConfirmAction from "../../components/ModalConfirmAction/ModalConfirmAction";
import { NotificationManager } from "react-notifications";
import FormsCreation from "../../components/FormsManagement/FormsCreation";
import PortalModal from "../../Portals/PortalModal";
import { useLazyQuery, useMutation } from "@apollo/client";
import { FORMS } from "../../GraphQL/Queries";
import { clientPolicyIngsight } from "../../App";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import { useHistory } from "react-router-dom";
import { CHANGE_STATUS_FORM, CREATE_FORM } from "../../GraphQL/Mutations";
import PointersLine from "../../components/Loaders/PointersLine/PointersLine";
import SearchIcon from "@material-ui/icons/Search";
import { Form } from "react-bootstrap";
import { AntTab, AntTabs } from "../../helpers/antTabs";
import { theme as themeConfig } from "../../themes/themes";

const FormsManagementContainer = () => {
  const [valueTabs, setValueTabs] = useState(0);
  const [selectedMenu, setSelectedMenu] = useState(["new", "Create Form"]);
  const [formTrigger, setFormTrigger] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorSelected, setAnchorSelected] = useState(null);
  const history = useHistory();
  const [, setMyForm] = useState({});
  const [myForms, setMyForms] = useState([]);
  const [startCursor, setStartCursor] = useState("");
  const [endCursor, setEndCursor] = useState("");
  const [allPages, setAllPages] = useState(null);
  const [filtered, setFiltered] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [showLoader, setshowLoader] = useState(false);
  const [rowsPerPageOptions] = useState([5, 10, 20]);
  const [searchTxt, setSearchTxt] = useState("");
  const rSearch = useRef();

  const [changeStatusForm] = useMutation(CHANGE_STATUS_FORM, {
    client: clientPolicyIngsight,
  });

  const [runQueryGetForms, { loading: loadingForms }] = useLazyQuery(FORMS, {
    fetchPolicy: "network-only",
    client: clientPolicyIngsight,
    onCompleted: (data) => {
      asignData(data);
      setshowLoader(false);
    },
  });

  const [openDeleteModal, setOpenDeleteModal] = useState(null);
  const [renderAgain, setrenderAgain] = useState(false);
  const [createFrom] = useMutation(CREATE_FORM, {
    client: clientPolicyIngsight,
  });

  const handleChange = (event, newValue) => {
    if (newValue === 0) setSelectedMenu(["new", "Create Form"]);
    setValueTabs(newValue);
  };

  let toggleChecked = (rowData) => {
    updateMyFormState(
      rowData,
      rowData.recordStatus === "Inactive" ? "Active" : "Inactive"
    );
  };

  let deleteMyForm = (rowData) => {
    updateMyFormState(rowData, "Deleted");
    setOpenDeleteModal(null);
  };

  let updateMyFormState = (rowData, state) => {
    let newState =
      "" + state === "Inactive"
        ? `${"INACTIVE"}`
        : "" + state === "Active"
          ? `${"ACTIVE"}`
          : "" + state === "Deleted"
            ? `${"DELETED"}`
            : "";
    changeStatusForm({
      variables: {
        idForm: rowData.idForm,
        newFormStatus: newState,
      },
    })
      .then((response) => {
        if (response.errors) {
          NotificationManager.warning(response.errors[0].message, "", 5000);
        } else {
          if (response.data.changeStatusForm.idForm) {
            if (state === "Deleted") {
              runQueryGetForms({
                variables: {
                  search: "",
                  first: rowsPerPage,
                },
              });
            } else {
              rowData.recordStatus = state;
              NotificationManager.success(
                "Status form is successfully updated",
                "",
                5000
              );
            }
            setrenderAgain(!renderAgain);
          }
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  let handleClickActions = (space, rowData) => {
    setAnchorEl(space.currentTarget);
    setAnchorSelected(rowData.idForm);
  };

  let handleCloseActions = () => {
    setAnchorEl(null);
    setAnchorSelected(null);
  };

  let handleEditForm = (rowData) => {
    setMyForm(rowData);
    setAnchorEl(null);
    setAnchorSelected(null);
    history.push({
      pathname: `/CreateForm`,
      state: { form: rowData, action: "edit", path: `/CreateForm` },
    });
  };

  useEffect(() => {
    if (formTrigger !== selectedMenu[0]) {
      setFormTrigger("");
    }
    if (formTrigger === selectedMenu[0]) {
      setFormTrigger(selectedMenu[0]);
    }
  }, [formTrigger, selectedMenu]);

  const handleFormCreation = (form) => {
    setFormTrigger("");
    setshowLoader(true);
    createFrom({
      variables: {
        name: form.formName,
        description: form.formDesc,
      },
    })
      .then((response) => {
        if (response?.data?.createForm?.idForm) {
          history.push({
            pathname: `/CreateForm`,
            state: {
              form: response.data.createForm,
              action: "edit",
              path: `/CreateForm`,
            },
          });
        }
        setshowLoader(false);
      })
      .catch((error) => {
        setshowLoader(false);
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const asignData = (data) => {
    setAllPages(data.formAdminList.totalCount);
    if (data.formAdminList.pageInfo.hasNextPage === true) {
      setEndCursor(data.formAdminList.pageInfo.endCursor);
    }
    if (data.formAdminList.pageInfo.hasPreviousPage === true) {
      setStartCursor(data.formAdminList.pageInfo.startCursor);
    }
    const formAdminList = data.formAdminList.nodes.map((fa) => ({ ...fa }));
    if (formAdminList) {
      setMyForms(formAdminList);
    }
  };

  const handleChangePage = (form, newPage) => {
    if (newPage > page) {
      setshowLoader(true);
      runQueryGetForms({
        variables: {
          search: filtered && searchTxt ? searchTxt : "",
          first: rowsPerPage,
          after: endCursor,
        },
      });
    }
    if (newPage < page) {
      setshowLoader(true);
      runQueryGetForms({
        variables: {
          search: filtered && searchTxt ? searchTxt : "",
          last: rowsPerPage,
          before: startCursor,
        },
      });
    }
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (form) => {
    setRowsPerPage(form.target.value ? parseInt(form.target.value) : 5);
    setPage(0);
    runQueryGetForms({
      variables: {
        search: filtered && searchTxt ? searchTxt : "",
        first: form.target.value ? parseInt(form.target.value) : 5,
      },
    });
  };

  const filterForms = () => {
    setFiltered(true);
    setPage(0);
    runQueryGetForms({
      variables: {
        search: searchTxt ? searchTxt : "",
        first: rowsPerPage,
      },
    });
  };

  useEffect(() => {
    if (searchTxt) {
      filterForms();
    }
  }, [searchTxt]);

  useEffect(() => {
    if (!filtered) {
      runQueryGetForms({
        variables: {
          search: "",
          first: rowsPerPage,
        },
      });
    }
  }, [filtered]);

  const getDataBySearch = () => {
    setSearchTxt(rSearch?.current?.value);
  };

  const applySearchOnBreak = () => {
    let timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(() => {
        getDataBySearch();
      }, 500);
    };
  };

  const handleSearch = applySearchOnBreak();

  const showDeleteModal = () => {
    return openDeleteModal ? (
      <ModalConfirmAction
        title={"Are you sure you want to delete this form?"}
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        fn={deleteMyForm}
      />
    ) : null;
  };

  const showSelectedMenu = () => {
    switch (selectedMenu[0]) {
      case "new":
        return (
          <Card
            iconplusactive={false}
            coloricon="#FFFFFF"
            colorBorder="#FFFFFF"
            icon="plus"
            code="new"
            title="Create Form"
            subtitle="form creation"
            footerText="Create new Form now"
            setFormTrigger={setFormTrigger}
          />
        );
      default:
        break;
    }
  };

  return (
    <>
      <GeneralStyle>
        <>
          <Paper position="static">
            <AntTabs
              aria-label="Forms Management"
              value={valueTabs}
              onChange={handleChange}
            >
              <AntTab label="Create Form" id="new" valueTabs={valueTabs} />
            </AntTabs>
          </Paper>

          <CardsWrapper className="pt-3 pb-2">
            {showSelectedMenu()}
            <ContentFilters>
              <SearchField>
                <SearchIcon />
                <Form.Control
                  type="text"
                  placeholder="Search"
                  onChange={handleSearch}
                  ref={rSearch}
                />
              </SearchField>
            </ContentFilters>
          </CardsWrapper>

          {loadingForms ? (
            <div
              style={{
                height: "25vh",
                gridColumn: "1/3",
                margin: "auto",
                alignItems: "center",
                display: "flex",
              }}
            >
              <PointersLine color={themeConfig.text.primary} />
            </div>
          ) : null}
          {selectedMenu[0] === "new" && !loadingForms && (
            <ListOfForms
              selectedMenu={selectedMenu}
              toggleChecked={toggleChecked}
              handleClickActions={handleClickActions}
              handleCloseActions={handleCloseActions}
              handleEditForm={handleEditForm}
              myForms={myForms}
              anchorEl={anchorEl}
              setAnchorEl={setAnchorEl}
              anchorSelected={anchorSelected}
              setAnchorSelected={setAnchorSelected}
              setOpenDeleteModal={setOpenDeleteModal}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              rowsPerPageOptions={rowsPerPageOptions}
              rowsPerPage={rowsPerPage}
              page={page}
              allPages={allPages}
            />
          )}
          {showDeleteModal()}
          {formTrigger && (
            <PortalModal>
              <FormsCreation
                setFormTrigger={setFormTrigger}
                handleFormCreation={handleFormCreation}
              />
            </PortalModal>
          )}
          {showLoader && <ModalLoader />}
        </>
      </GeneralStyle>
    </>
  );
};

export default FormsManagementContainer;
